import { render } from "./1Difference.vue?vue&type=template&id=96c05384&scoped=true"
import script from "./1Difference.vue?vue&type=script&lang=js"
export * from "./1Difference.vue?vue&type=script&lang=js"

import "./1Difference.vue?vue&type=style&index=0&id=96c05384&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-96c05384"

export default script